import { render } from "./IncomingGoodsProducer.vue?vue&type=template&id=19465c8e"
import script from "./IncomingGoodsProducer.vue?vue&type=script&lang=js"
export * from "./IncomingGoodsProducer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__